<div class="max-w-7xl mx-auto mt-8 mb-4">

    @if ((group$ | async)?.memberStatus == membershipStatus.active) {
    <div class="flex justify-between items-center w-full mb-4">

        <div class="flex flex-row justify-between">
            <app-btn-back routeTo="/groups"></app-btn-back>
        </div>

        <div class="relative flex items-center">
            <app-btn-fab (click)="toggleDropdown($event); $event.stopPropagation()" icon="fas fa-ellipsis-vertical"
                bgColor="bg-transparent hover:bg-gray-200 active:bg-gray-300"></app-btn-fab>
            <div
                class="absolute right-0 top-full mt-1 min-w-48 z-20 bg-white text-base p-1 list-none text-left rounded-md shadow-lg {{ dropdownPopoverShow ? 'block' : 'hidden'}}">
                @let user = (user$ | async);
                <a [routerLink]="['../noticeboard']" class="hover:bg-gray-100 cursor-pointer active:border-none text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent
                                                        text-blueGray-700">
                    <i class="fas fa-bullhorn mr-2 leading-relaxed"></i>
                    Noticeboard
                </a>
                @if ((myRoles$ | async)?.management) {
                <a [routerLink]="['../calendar']" class="hover:bg-gray-100 cursor-pointer active:border-none text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent
                text-blueGray-700">
                    <i class="fas fa-calendar-days mr-2 leading-relaxed"></i>
                    Events Calendar
                </a>
                }
                @if ((myRoles$ | async)?.faculty) {
                <a [routerLink]="['../faculty', user?.uid]" fragment="sessions" class="hover:bg-gray-100 cursor-pointer active:border-none text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent
                text-blueGray-700"><i class="fas fa-chalkboard-user mr-2 leading-relaxed"></i>
                    My Teaching Workspace
                </a>
                }
                @if ((myRoles$ | async)?.parents) {
                <a [routerLink]="['../parents', user?.uid]" fragment="sessions" class="hover:bg-gray-100 cursor-pointer active:border-none text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent
                text-blueGray-700"><i class="fas fa-children mr-2 leading-relaxed"></i>
                    My Children
                </a>
                }
                @if ((myRoles$ | async)?.students) {
                <a [routerLink]="['../students', user?.uid]" fragment="sessions" class="hover:bg-gray-100 cursor-pointer active:border-none text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent
                                    text-blueGray-700"><i class="fas fa-child mr-2 leading-relaxed"></i>
                    My Learning Space
                </a>
                }
                <a [routerLink]="['../members']" class="hover:bg-gray-100 cursor-pointer active:border-none text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent
                                    text-blueGray-700">
                    <i class="fas fa-users mr-2 leading-relaxed"></i>
                    Members
                </a>
                <a [routerLink]="['../lessons']" class="hover:bg-gray-100 cursor-pointer active:border-none text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent
                                    text-blueGray-700">
                    <i class="fas fa-book mr-2 leading-relaxed"></i>
                    Lessons
                </a>
                @if ((myRoles$ | async)?.management) {
                <a [routerLink]="['../grades']" class="hover:bg-gray-100 cursor-pointer active:border-none text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent
                text-blueGray-700">
                    <i class="fas fa-graduation-cap mr-2 leading-relaxed"></i>
                    Grades
                </a>
                }

                <a [routerLink]="['../quizzes']" class="hover:bg-gray-100 cursor-pointer active:border-none text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent
                                    text-blueGray-700">
                    <i class="fas fa-circle-question mr-2 leading-relaxed"></i>
                    Quizzes
                </a>

                @if ((myRoles$ | async)?.management) {
                <a [routerLink]="['../details']" class="hover:bg-gray-100 cursor-pointer active:border-none text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent
                    text-blueGray-700">
                    <i class="fas fa-gear mr-2 leading-relaxed"></i>
                    Settings
                </a>
                }
            </div>
        </div>
    </div>
    }

    <div class="mb-4 border-0 w-full">

        <h1 class="font-semibold text-2xl text-blueGray-700 mb-4">
            Dashboard
        </h1>

        <!-- Analytics tabs: presidents and principals only (the only roles Firestore lets read them) -->
        @let showAnalytics = (myRoles$ | async)?.management === true;
        @if (showAnalytics) {
        <div class="w-full mb-6">
            <div class="border-b border-gray-200 flex items-center justify-between">
                <nav class="flex space-x-4">
                    <button (click)="setActiveTab('overview')"
                        [class]="activeTab === 'overview' ? 'border-secondary-500 text-secondary-600' : 'border-transparent text-gray-500'"
                        class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm focus:outline-none focus:ring-0">
                        Overview
                    </button>
                    <button (click)="setActiveTab('attendance')"
                        [class]="activeTab === 'attendance' ? 'border-secondary-500 text-secondary-600' : 'border-transparent text-gray-500'"
                        class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm focus:outline-none focus:ring-0">
                        Attendance
                    </button>
                    <button (click)="setActiveTab('academics')"
                        [class]="activeTab === 'academics' ? 'border-secondary-500 text-secondary-600' : 'border-transparent text-gray-500'"
                        class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm focus:outline-none focus:ring-0">
                        Academics
                    </button>
                </nav>
            </div>
        </div>
        }

        @let loadingStats = loadingStats$ | async;

        @if (showAnalytics && activeTab === 'overview') {
        @let g = group$ | async;
        @defer {
        <app-school-analytics section="overview" [countsLoading]="!!loadingStats" (refreshCounts)="refreshStats()"
            [counts]="{ students: g?.students, parents: g?.parents, faculty: g?.teachers, grades: g?.grades, pending: g?.new_members }"></app-school-analytics>
        } @placeholder {
        <app-analytics-skeleton section="overview"></app-analytics-skeleton>
        }
        } @else if (!showAnalytics) {
        @if (group$ | async; as group) {
        <div class="flex flex-row gap-4 w-full flex-nowrap">
            <div
                class="col-span-1 row-span-1 bg-white rounded shadow-lg px-4 py-2 flex flex-col gap-2 w-full justify-between">
                <div class="flex flex-row justify-between"><span
                        class="w-full text-start text-sm text-blueGray-400">Total
                        Faculty</span><btn-icon [icon]="'fas fa-refresh'" (onClick)="refreshStats()" padding=""
                        textColor="text-blueGray-300" textHoverColor="text-primary-500"></btn-icon>
                </div>
                @if (loadingStats) {
                <div class="animate-pulse h-6 bg-slate-200 rounded w-1/2 ml-auto"></div>
                } @else {
                <span class="w-full text-5xl text-right font-bold text-primary-500">{{group?.teachers ??
                    '-'}}</span>
                }
            </div>
            <div
                class="col-span-1 row-span-1 bg-white rounded shadow-lg px-4 py-2 flex flex-col gap-2 w-full justify-between">
                <div class="flex flex-row justify-between"><span
                        class="w-full text-start text-sm text-blueGray-400">Total Students</span><btn-icon
                        [icon]="'fas fa-refresh'" (onClick)="refreshStats()" padding="" textColor="text-blueGray-300"
                        textHoverColor="text-primary-500"></btn-icon>
                </div>
                @if (loadingStats) {
                <div class="animate-pulse h-6 bg-slate-200 rounded w-1/2 ml-auto"></div>
                } @else {
                <span class="w-full text-5xl text-right font-bold text-primary-500">{{group?.students ??
                    '-'}}</span>
                }
            </div>
            <div
                class="col-span-1 row-span-1 bg-white rounded shadow-lg px-4 py-2 flex flex-col gap-2 w-full justify-between">
                <div class="flex flex-row justify-between"><span
                        class="w-full text-start text-sm text-blueGray-400">Total
                        Parents</span><btn-icon [icon]="'fas fa-refresh'" (onClick)="refreshStats()" padding=""
                        textColor="text-blueGray-300" textHoverColor="text-primary-500"></btn-icon>
                </div>
                @if (loadingStats) {
                <div class="animate-pulse h-6 bg-slate-200 rounded w-1/2 ml-auto"></div>
                } @else {
                <span class="w-full text-5xl text-right font-bold text-primary-500">{{group?.parents ??
                    '-'}}</span>
                }
            </div>
            <div
                class="col-span-1 row-span-1 bg-white rounded shadow-lg px-4 py-2 flex flex-col gap-2 w-full justify-between">
                <div class="flex flex-row justify-between"><span class="w-full text-start text-sm text-blueGray-400">New
                        Requests</span>
                    <btn-icon [icon]="'fas fa-refresh'" (onClick)="refreshStats()" padding=""
                        textColor="text-blueGray-300" textHoverColor="text-primary-500"></btn-icon>
                </div>
                @if (loadingStats) {
                <div class="animate-pulse h-6 bg-slate-200 rounded w-1/2 ml-auto"></div>
                } @else {
                <span class="w-full text-5xl text-right font-bold text-primary-500">{{group?.new_members ??
                    '-'}}</span>
                }
            </div>
        </div>

        <ng-container *ngTemplateOutlet="studentsByGradeCard; context: { withTotal: true }"></ng-container>
        <ng-container *ngTemplateOutlet="lessonStatusCard"></ng-container>
        }
        } @else if (activeTab === 'attendance') {
        @defer {
        <app-school-analytics section="attendance"></app-school-analytics>
        } @placeholder {
        <app-analytics-skeleton section="attendance"></app-analytics-skeleton>
        }
        } @else if (activeTab === 'academics') {
        <section class="bg-white rounded shadow-lg p-5 mb-6">
            <div class="flex flex-row justify-between items-start">
                <div>
                    <h2 class="text-base font-semibold text-blueGray-700">Academic lesson(s) status</h2>
                    <p class="mb-3 text-sm text-blueGray-500">Lessons completed and still open, per grade.</p>
                </div>
                <btn-icon [icon]="'fas fa-refresh'" (onClick)="refreshLessons()" padding=""
                    textColor="text-blueGray-300" textHoverColor="text-primary-500"></btn-icon>
            </div>
            @if (loadingStats) {
            <div class="animate-pulse h-6 bg-slate-200 rounded w-1/2 ml-auto"></div>
            } @else {
            <app-academic-status></app-academic-status>
            }
        </section>
        @defer {
        <app-school-analytics section="academics"></app-school-analytics>
        } @placeholder {
        <app-analytics-skeleton section="academics"></app-analytics-skeleton>
        }
        }

        <ng-template #studentsByGradeCard let-withTotal="withTotal">
        <!-- Number of Students By Grade -->
        <div class="flex flex-row flex-nowrap gap-4 mt-4 w-full">
            <div class="bg-white rounded shadow-lg px-4 py-2 gap-2 flex flex-col justify-between" [ngClass]="withTotal ? 'w-9/12' : 'w-full'">
                <div class="flex flex-row justify-between"><span
                        class="w-full text-start text-sm text-blueGray-400">Students By Grade</span>
                    <btn-icon [icon]="'fas fa-refresh'" (onClick)="refreshStudents()" padding=""
                        textColor="text-blueGray-300" textHoverColor="text-primary-500"></btn-icon>
                </div>
                @if (loadingStats) {
                <div class="animate-pulse h-6 bg-slate-200 rounded w-1/2 ml-auto"></div>
                } @else {
                <app-students-by-grade></app-students-by-grade>
                }
            </div>
            @if (withTotal) {
            <div class="bg-white rounded shadow-lg px-4 py-2 flex flex-col gap-2 h-1/3 w-3/12 justify-between">
                <span class="w-full text-start text-sm text-blueGray-300">Total Grades</span>
                @if (loadingStats) {
                <div class="animate-pulse h-6 bg-slate-200 rounded w-1/2 ml-auto"></div>
                } @else {
                <span class="w-full text-5xl text-right font-bold text-primary-500">{{ (group$ | async)?.grades }}</span>
                }
            </div>
            }
        </div>

        </ng-template>

        <ng-template #lessonStatusCard>
        <!-- Academic Lessons Status -->
        <div class="bg-white rounded shadow-lg px-4 py-2 flex-nowrap gap-4 mt-4 w-full flex flex-col justify-between">
            <div class="flex flex-row justify-between">
                <span class="w-full text-start text-sm text-blueGray-400">Academic Lesson(s) Status</span><btn-icon
                    [icon]="'fas fa-refresh'" (onClick)="refreshLessons()" padding="" textColor="text-blueGray-300"
                    textHoverColor="text-primary-500"></btn-icon>
            </div>

            @if (loadingStats) {
            <div class="animate-pulse h-6 bg-slate-200 rounded w-1/2 ml-auto"></div>
            } @else {
            <app-academic-status></app-academic-status>
            }
        </div>
        </ng-template>
    </div>
</div>